import { render, staticRenderFns } from "./welcome_flexi_life.vue?vue&type=template&id=65f27c3f&scoped=true"
import script from "./welcome_flexi_life.vue?vue&type=script&lang=js"
export * from "./welcome_flexi_life.vue?vue&type=script&lang=js"
import style0 from "./welcome_flexi_life.vue?vue&type=style&index=0&id=65f27c3f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f27c3f",
  null
  
)

/* custom blocks */
import block0 from "./welcome_flexi_life.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports